<template>
    <div class="mt-4">
        <div class="panel platform-tables">
            <div class="table-wrapper">
                <div class="table-container">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Based on</th>
                            <th>
                                <a :href="route('metadata.master-tables.edit', masterTable.id)" target="_blank">
                                    {{ masterTable.name }}
                                </a>
                            </th>
                            <th v-for="table in platformTables">
                                <a :href="route('metadata.platform-tables.edit', table.id)" target="_blank">
                                    {{ table.name }}
                                </a>
                            </th>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <th>United</th>
                            <th v-for="table in platformTables">
                                <a :href="route('metadata.platform-integrations.edit', table.connection_type.id)"
                                   target="_blank">
                                    {{ table.connection_type.title }}
                                </a>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="field in masterFields">
                            <td>
                                {{ field.type }}
                            </td>
                            <td>
                                <a :href="route('metadata.master-fields.edit', field.id)" target="_blank">
                                    {{ field.name }}
                                </a>
                            </td>
                            <td v-for="table in platformTables" v-html="getFieldImplementation(table.fields, field)"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {METADATA_STATUSES} from "../statuses";

export default {
    name: 'table-platforms',
    props: {
        platformTables: {
            type: Array,
            required: true,
            default: []
        },
        masterTable: {
            type: Object,
            required: true,
            default: {}
        },
        masterFields: {
            type: Array,
            required: true,
            default: []
        }
    },
    methods: {
        getFieldImplementation(fields, masterField) {
            let implementation = '';
            let platformField = fields.filter((field) => {
                return field.master_field_id === masterField.id;
            });
            if (platformField[0] && platformField[0].implementation) {
                let internalReferences = platformField[0].implementation.internal_references;
                if (internalReferences) {
                    implementation = internalReferences.join('<br>');
                }
            }
            return implementation + this.getIconStatusField(platformField[0].status);
        },
        getIconStatusField(status) {
            let icon = METADATA_STATUSES[status].icon;
            let statusName = METADATA_STATUSES[status].name;
            return '<span class=metadata-status-icon title="' + statusName + '"><ion-icon name="' + icon + '"></ion-icon></span>'
        }
    }
}
</script>
